// Helper methods for user provider.
import jwt_decode from 'jwt-decode';

export const getUserIdFromToken = (accessToken) => {
  const decodedToken = jwt_decode(accessToken);
  return decodedToken.userid;
};
